import { CheckCircle2 } from 'lucide-react';
import { Pill } from '../ui/Pill';
import type { OnboardingItemStatus } from '../../hooks/onboardingOps';

/** A submitted task can be reopened back to pending; a pending one can't. */
export function canReopen(status: OnboardingItemStatus): boolean {
  return (
    status === 'complete' ||
    status === 'awaiting_review' ||
    status === 'changes_requested'
  );
}

/** Shared lifecycle pill for the per-person assignment panels. */
export function ItemStatusPill({ status }: { status: OnboardingItemStatus }) {
  switch (status) {
    case 'complete':
      return (
        <Pill tone="success" size="sm" icon={<CheckCircle2 className="h-3 w-3" />}>
          Done
        </Pill>
      );
    case 'awaiting_review':
      return <Pill tone="info" size="sm">In review</Pill>;
    case 'changes_requested':
      return <Pill tone="warning" size="sm">Changes</Pill>;
    case 'pending':
      return <Pill tone="neutral" size="sm">To do</Pill>;
    default:
      return null;
  }
}
